<template>
  <div>
    <div class="card_content" v-if="attachment" :style="{'margin-top': readOnly ? '0px' : '20px'}">
      <el-button  v-if="!readOnly" size="small" :style="{'margin-bottom': readOnly ? '0px' : '20px'}" @click="openUpload" type="primary"><i class="iconfont iconhetongshangchuan"></i>附件上传</el-button>
      <div class="file_list">
        <div class="file_item_out" :style="{'z-index': 100 - index}" v-for="(item, index) in showFileList" :key="index">
          <div class="file_item" :style="{'z-index': 200 - index}">
						<div class="icon_out">
                <svg class="icon" aria-hidden="true" @click="preview(item)">
                <use v-if="item.fileType === 'image/jpeg'" xlink:href="#iconJPG" />
                <use v-if="item.fileType === 'image/png'" xlink:href="#iconPNG" />
                <use v-if="item.fileType === 'application/pdf'" xlink:href="#iconPDF" />
                <use v-if="item.fileType !== 'application/pdf' && item.fileType !== 'image/jpeg' && item.fileType !== 'image/png'" xlink:href="#iconqita" />
              </svg>
            </div>
						<div class="center_info" @click="preview(item)">
						  <el-tooltip class="item" effect="dark" :content="item.filePath" placement="top">
                <h5>{{item.filePath}}</h5>
              </el-tooltip>
						  <p  class="add-tab-box"><span class="add-tag" :class="{'tag-name': item.tagName}" @click.stop="addTag(item, index)">{{item.tagName ? item.tagName : '添加标签'}}</span><span>{{item.fileSize}}</span></p>
						</div>
						<!-- <div v-show="!readOnly" class="right_delete" @click="deleteFile(index)">
						  <i class="iconfont iconshanchu2"></i>
						</div> -->
            <div class="hover_over">
              <div class="hover_over_download" @click="downloadFile(index)">下载</div>
              <div v-if="!readOnly" class="hover_over_delete" @click="deleteFile(index)">删除</div>
            </div>
					</div>
        </div>
				
      </div>
    </div>
    <input type="file" style="display: none;" @change="uploadEvent" ref="uploadInput">
		<el-dialog
		  v-dialogDrag
		  :close-on-click-modal="false"
		  title="添加标签"
		  :show-close="true"
		  :visible="dialogVisible"
		  :before-close="handleBeforeClose2"
		  width="600px"
		  append-to-body
		>
		  <div>
		    <el-form
		      ref="form"
		      class="search-form"
		      label-position="right"
		      :model="form"
		      label-width="70px"
		    >
		      <el-form-item label=" " label-width="0px">
		        <el-select size="mini" v-model="tagObj" @change="getTag" value-key="tagCode"  v-if="fjbqDicts && fjbqDicts.length">
							<el-option 
								v-for="item in list"
								:key="item.tagCode"
								:label="item.dictionaryValue"
								:value="item"
							>{{item.dictionaryValue}}</el-option>
						</el-select>
		      </el-form-item>
		    </el-form>
		  </div>
		  <span slot="footer" class="dialog-footer">
		    <el-button class="plr28" size="mini" type="info" plain @click="dialogVisible = false">取消</el-button>
		    <el-button class="plr28" type="primary" size="mini" @click="handleConfirm2">确定</el-button>
		  </span>
		</el-dialog>
  </div>
</template>

<script>

// import { getIdentity, preview, 
//   generateSingleFileToZip,
//   requestFileStatus,
//   downloadZip } from '@/api/sys';
import { mapState } from 'vuex'

export default {
  name: 'UploadUtil',
  data() {
    return {
      attachment: true,
      showFileList: [],
      fileinfo: {
        fileType: null, // 文件类型 // jpg: image/jpeg, png: image/png, pdf: application/pdf
        filePath: null, // 文件名称
        createTime: null, // 上传时间
        fileSize: null, // 文件大小
      },
      currentItem: null,
			dialogVisible: false,
			form: {
				tagCode: '',
				tagName: '',
				fileId : ''
			},
			tagObj: {},
      chooseIndex: '',
      list: []
    }
  },
	computed: {
	  ...mapState('htxt/dictionary', ['fjbqDicts'])
	},
  props: {
    id: {
      default: null
    },
    contractId: {
      default: null
    },
		tempFileList: {
      type:Array,
      default: function() {
        return []
			}
		},
    readOnly: {
      default: false
    },
		fileType: {
		  default: 6
    },
    addTagFun: {
      type: Function,
    },
    uploadFileFun: {
      type: Function,
    },
    deleteFileFun: {
      type: Function,
    },
    getDetailFun: {
      type: Function,
    },
    showAddTag: {
      type: Boolean,
      default: true
    }

  },
  created() {
    this.list = this.fjbqDicts.map((item) => {
      item.tagCode = item.dictionaryCode
      item.tagName = item.dictionaryValue
      return item
    })
  },
  watch: {
    tempFileList: {
      handler(newV, oldV) {
        this.showFileList = newV;
      },
      deep: true
    }
  },
  mounted() {
    if (this.id || this.contractId) {
      this.getFileList();
    }
  },
  beforeDestroy() {
   
  },
  methods: {
    openUpload() {
      if (this.$refs && this.$refs['uploadInput']) {
        this.$refs['uploadInput'].click();
      }
    },
    uploadEvent() {
      let file = this.$refs['uploadInput'].files[0];
      if (file) {
        this.uploadFile(file, file.type, this.calcSize(file.size));
      }
    },
    calcSize(size) {
      if (size > 1024 * 1024) {
        return Math.round(size / 1024 / 1024 * 100) / 100 + 'MB';
      }
      if (size > 1024) {
        return Math.round(size / 1024 * 100) / 100 + 'KB';
      }
      return size + 'B';
    },

    deleteFile(index) {
      this.currentItem = this.showFileList[index];
      this.$confirm(`确定移除 ${ this.currentItem.filePath }？`).then(() => {
        this.handelDelete();
      });
    },
    handelDelete() {
      let arr = [];
      if (this.showFileList && this.showFileList.length) {
        this.showFileList.forEach(item => {
          if (item.id === this.currentItem.id) {
            this.deleteFileFun({fileId:item.id});
          } else {
            arr.push(item);
          }
        });
      }
      this.showFileList = arr;
      this.$emit('setFile', this.showFileList)
    },
    async getFileList() {
      let params = {}
      if (this.contractId) {
        params.contractId = this.contractId
      } else {
        params.id = this.id
      }
      const result = await this.getDetailFun(params);
      if (result.code === 200) {
        if (this.contractId) {
          this.showFileList = result.data.contractFileList || result.data.fileList;
        } else {
          this.showFileList = result.data.attachmentList;
        }
      }
    },
    async uploadFile(file, type, size) {
      let formData = new FormData();
      formData.append('fileData', file);
      formData.append('fileType', type);
      formData.append('fileSize', size);
      if (this.id) {
        formData.append('id', this.id);
      }
      if (this.contractId) {
        formData.append('contractId', this.contractId);
      }
      let result = await this.uploadFileFun(formData);
      if (result.code === 200) {
        this.$message({
          type: 'success',
          message: '上传成功'
        })
        if (result.code === 200) {
          this.showFileList.push(result.data)
          this.$emit('setFile', this.showFileList)
        }
      } else {
        this.$message({
          type: 'warning',
          message: '上传失败，请重试'
        })
      }
      this.$refs['uploadInput'].value = '';
    },
		addTag(item, index) {
      if (this.readOnly) {
        return
      }
			this.tagObj = {}
			this.form.fileId =  item.id
      this.chooseIndex = index
      
      if (!item.tagCode) {
        this.tagObj = {}
      } else {
        this.$set(this.tagObj, 'tagCode', item.tagCode)
        this.$set(this.tagObj, 'tagName', item.tagName)
      }
      this.dialogVisible = true
      console.log(this.tagObj)
		},
		handleBeforeClose2(done) {
		  this.dialogVisible = false
		  done()
		},
		async handleConfirm2() {
			const res = await this.addTagFun(this.form)
			if (res.code === 200) {
				this.$message.success('添加成功')
				this.dialogVisible = false
        this.showFileList[this.chooseIndex].tagName = this.form.tagName
        this.showFileList[this.chooseIndex].tagCode = this.form.tagCode
			}
		},
		getTag(value) {
			this.form.tagCode = value.dictionaryCode
			this.form.tagName = value.dictionaryValue
		},
		async preview(item) {
      console.log(item)
		  const identity = await getIdentity();
		  let identityId = null;
		  if (identity.code === 200) {
		    identityId = identity.data.identity
		    preview({
		      fileId: item.id,
		      fileType: item.relationType,
		      identity: identityId
		    });
		  }
    },
    downloadFile(index) {
      this.download(this.showFileList[index].id, this.showFileList[index].relationType);
    },
    async download(relationFileId, relationType) {
      if (this.downloading) {
        return this.$message.success('正在生成文件，请稍后……');
      }
      let res1 = await generateSingleFileToZip({
        relationFileId: relationFileId,
        relationType: relationType,
      })
      if (res1 && res1.data) {
        let code = res1.data
        const res2 = await requestFileStatus({ fileOperateId: code.operateId })
        if (res2 && res2.data && res2.data.status === 2) {
          // 说明生成成功
          code.fileOperateId = code.operateId;
          downloadZip(code)
        } else if (res2 && res2.data && res2.data.status === 1) {
          this.downloading = true
          // 提示
          this.timerForCheck = setInterval(() => {
            requestFileStatus({ fileOperateId: code.operateId }).then(res3 => {
              if (res3 && res3.data && res3.data.status === 2) {
                downloadZip({ fileOperateId: code.operateId })
                this.downloading = false
                clearInterval(this.timerForCheck)
              }
              if (res3 && res3.data && res3.data.status === 0) {
                this.downloading = false
                clearInterval(this.timerForCheck)
              }
            })
          }, 2000)
        } else if (res2 && res2.data && res2.data.status === 3) {
          return this.$message.error('所选合同没有附件')
        } else {
          return this.$message.error('文件生成失败')
        }
        this.$message.success('正在生成文件，请稍后……');
      }
    },
  }
}
</script>

<style scoped lang="scss">
.card {
  .add-tab-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
	.add-tag {
		font-size:12px;
		color: #999999;
		margin-left: 8px;
		display: inline-block;
		line-height: 12px;
		padding: 1px 2px;
		border: 1px solid #999999;
		border-radius: 2px;
	}
	.tag-name {
		color: #5B8CFF;
		border-color: #5B8CFF;
	}
  background-color: #fff;
  margin: 12px 12px 0px 12px;
  padding: 20px;
  .card_title {
    font-size:16px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:16px;
    cursor: pointer;
  }
  .card_content {
    margin-top: 20px;
  }
}
.card_switch {
  color: rgba(204, 204, 204, 1);
  margin-right: 8px;
  .iconfont {
    font-size: 16px;
  }
}
.card_title:hover .card_switch{
  color: rgba(91, 140, 255, 1);
}
.card_button {
  margin-top: 20px;
  margin-right: 40px;
  margin-bottom: 0px;
}
.file_list {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  .icon {
    width: 28px;
    height: 28px;
  }
  .file_item_out {
    width: 240px;
    height: 54px;
    // margin-top: 20px;
    margin-right: 20px;
    position: relative;
  }
  .file_item {
    cursor: pointer;
    width: 240px;
    height: 54px;
    overflow: hidden;
    border-radius:4px;
    border:1px solid rgba(238,238,238,1);
    padding: 12px;
    padding-right: 0px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    position: absolute;
    transition: all .2s ease;
  }
  .file_item:hover {
    width: 324px;
    box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.1);
  }
  .hover_over {
    width: 80px;
    display: flex;
    justify-content: flex-end;
    background-color: #fff;
    div {
      height: 100%;
      width: 40px;
      text-align: center;
      line-height: 52px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
    }
		.hover_over_download {
      background-color: #5B8CFF;
    }
		.hover_over_delete {
      background-color: #FF1400;
    }
  }
  .center_info {
    width: 178px;
    margin-left: 12px;
    margin-right: 12px;
    h5 {
      width: 178px;
      font-size:12px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(51,51,51,1);
      line-height:12px;
      margin: 0px;
      margin-bottom: 6px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: pointer;
    }
    p {
      margin: 0px;
      font-size:12px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(153,153,153,1);
      line-height:12px;
      span {
        float: right;
      }
    }
  }
  .right_delete {
    width: 38px;
    text-align: right;
    color: rgba(204, 204, 204, 1);
    cursor: pointer;
    height: 28px;
    &:hover i{
      color: rgba(255, 20, 0, 1);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/AttachmentUpload/index.vue